import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/device/mobile_/connect')({
  beforeLoad: () => {
    throw redirect({
      to: '/device/apps/connect',
      replace: true,
    });
  },
});
